var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefinitionSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Definition-Search-Book--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Definition Search Book Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "definition-search-book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fill: "#ea7f4a00",
    d: "M5.5 0.5h-5v10h12a1 1 0 0 0 1 -1v-9h-5A1.5 1.5 0 0 0 7 2 1.5 1.5 0 0 0 5.5 0.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fill: "#ffffff",
    d: "M10 12.5a2.5 2.5 0 1 0 0 -5 2.5 2.5 0 0 0 0 5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 12.5a2.5 2.5 0 1 0 0 -5 2.5 2.5 0 0 0 0 5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.5 13.5 -1.73 -1.73",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 2652",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 2v0A1.5 1.5 0 0 0 5.5 0.5h-5v10h5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 2655",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 7.5v-7l-5 0A1.5 1.5 0 0 0 7 2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 2656",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 2v4.5",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinitionSearch);
export default __webpack_public_path__ + "static/media/Definition-Search.4527dea5b3b80166f707266a3ef667f9.svg";
export { ForwardRef as ReactComponent };